export default "__VITE_ASSET__BLHt4iqb__";